export default () => {
  const config = useRuntimeConfig();
  const isReCaptchaReady = ref<boolean>(false);

  const { unload: unloadRecaptcha } = useScriptTag(
    `https://www.google.com/recaptcha/api.js?render=${config.public.recaptcha.publicKey}`,
    () => {
      isReCaptchaReady.value = true;
    },
    {
      async: true,
      defer: true,
    },
  );

  const removeRecaptchaBadge = () => {
    const recaptchaBadge = document.querySelector('.grecaptcha-badge');

    if (recaptchaBadge == null) return;

    const parent = recaptchaBadge.parentElement;
    if (parent.id !== '__nuxt') {
      document.body.removeChild(parent);
    }
  };

  const getReCaptchaToken = async () => {
    let reCaptchaToken: string;

    try {
      reCaptchaToken = await window.grecaptcha.execute(
        config.public.recaptcha.publicKey,
        {
          action: 'register',
        },
      );
    } catch (error) {
      // do nothing, push error message below
    }

    return reCaptchaToken;
  };

  onUnmounted(async () => {
    await unloadRecaptcha();
    removeRecaptchaBadge();
  });

  return { isReCaptchaReady, getReCaptchaToken };
};
